// extracted by mini-css-extract-plugin
module.exports = {"root":"contactForm_root__SoP1u","fadeIn":"contactForm_fadeIn__1V-ln","submitted":"contactForm_submitted__eGnWn"};